'use client';

import {
  Popover as MuiPopover,
  PopoverProps as MuiPopoverProps,
} from '@mui/material';
import { ReactNode } from 'react';

type AppPopoverProps = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: ReactNode;
  anchorOrigin?: MuiPopoverProps['anchorOrigin'];
  transformOrigin?: MuiPopoverProps['transformOrigin'];
  disablePortal?: boolean;
  // * Extendable for future overrides.
} & Omit<
  MuiPopoverProps,
  | 'open'
  | 'anchorEl'
  | 'onClose'
  | 'children'
  | 'anchorOrigin'
  | 'transformOrigin'
>;

export function Popover({
  open,
  anchorEl,
  onClose,
  children,
  anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
  transformOrigin = { vertical: 'top', horizontal: 'left' },
  disablePortal = false,
  ...rest
}: AppPopoverProps) {
  return (
    <MuiPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      disablePortal={disablePortal}
      {...rest}
    >
      <div style={{ padding: 8, minWidth: 200 }}>{children}</div>
    </MuiPopover>
  );
}
